<template>
  <v-container fluid class="pa-5">
    <v-card class="card-container pa-6" elevation="0">
      <v-row>
        <v-col cols="12" class="mb-4">
          <span class="title-text">ตั้งค่าระบบ (Settings)</span>
        </v-col>

        <v-col cols="12">
          <v-tabs v-model="activeTab" color="#F4811F">
            <v-tab>การชำระเงิน / QR Code</v-tab>
            <v-tab>การล้างข้อมูลอัตโนมัติ</v-tab>
            <v-tab>โปรโมชั่น</v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab" class="mt-6">
            <v-tab-item>
              <AdminPaymentSettings />
            </v-tab-item>
            <v-tab-item>
              <AdminSystemSettings />
            </v-tab-item>
            <v-tab-item>
              <AdminPromotionSettings />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import AdminPaymentSettings from "@/components/AdminPaymentSettings/AdminPaymentSettings.vue";
import AdminSystemSettings from "@/components/AdminPaymentSettings/AdminSystemSettings.vue";
import AdminPromotionSettings from "@/components/AdminPaymentSettings/AdminPromotionSettings.vue";

export default {
  name: "AdminSettings",
  components: {
    AdminPaymentSettings,
    AdminSystemSettings,
    AdminPromotionSettings,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>

<style scoped>
.title-text {
  font-size: 24px;
  font-weight: 700;
  color: #1f2a39;
}
.card-container {
  border-radius: 16px !important;
  box-shadow: 0 0 2px 0 #1018280d !important;
  background-color: white !important;
}
</style>
